export default {
  afterSetLocaleMessage() {
  }
}
